import { inheritsLoose as _inheritsLoose, assertThisInitialized as _assertThisInitialized, wrapNativeSuper as _wrapNativeSuper } from './_virtual/_rollupPluginBabelHelpers.js';

var SerializationError = /*#__PURE__*/function (_Error2) {
  _inheritsLoose(SerializationError, _Error2);

  function SerializationError(message) {
    var _this2;

    _this2 = _Error2.call(this, message) || this;
    _this2.message = message;
    _this2.name = _this2.constructor.name;

    if (Error.captureStackTrace) {
      Error.captureStackTrace(_assertThisInitialized(_this2), _this2.constructor);
    }

    return _this2;
  }

  return SerializationError;
}( /*#__PURE__*/_wrapNativeSuper(Error));
var DeserializationError = /*#__PURE__*/function (_Error3) {
  _inheritsLoose(DeserializationError, _Error3);

  function DeserializationError(message) {
    var _this3;

    _this3 = _Error3.call(this, message) || this;
    _this3.message = message;
    _this3.name = _this3.constructor.name;

    if (Error.captureStackTrace) {
      Error.captureStackTrace(_assertThisInitialized(_this3), _this3.constructor);
    }

    return _this3;
  }

  return DeserializationError;
}( /*#__PURE__*/_wrapNativeSuper(Error));
var NotImplementedError = /*#__PURE__*/function (_Error4) {
  _inheritsLoose(NotImplementedError, _Error4);

  function NotImplementedError(message) {
    var _this4;

    _this4 = _Error4.call(this, message) || this;
    _this4.message = message;
    _this4.name = _this4.constructor.name;

    if (Error.captureStackTrace) {
      Error.captureStackTrace(_assertThisInitialized(_this4), _this4.constructor);
    }

    return _this4;
  }

  return NotImplementedError;
}( /*#__PURE__*/_wrapNativeSuper(Error));
var SigningError = /*#__PURE__*/function (_Error5) {
  _inheritsLoose(SigningError, _Error5);

  function SigningError(message) {
    var _this5;

    _this5 = _Error5.call(this, message) || this;
    _this5.message = message;
    _this5.name = _this5.constructor.name;

    if (Error.captureStackTrace) {
      Error.captureStackTrace(_assertThisInitialized(_this5), _this5.constructor);
    }

    return _this5;
  }

  return SigningError;
}( /*#__PURE__*/_wrapNativeSuper(Error));

export { DeserializationError, NotImplementedError, SerializationError, SigningError };
//# sourceMappingURL=errors.esm.js.map
